import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { RouterModule } from '@angular/router';
import { LibFormContainerModule } from '../form-container/form-container.module';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { AuthGuard } from './auth.guard';
import { AuthenticationService } from './authentication.service';
import { AuthenticationStore } from './authentication.store';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { UserService } from './user.service';

@NgModule({
    imports: [
        CommonModule,
        LibFormContainerModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        RouterModule,
    ],
    exports: [LoginComponent, LogoutComponent, AccessDeniedComponent],
    declarations: [LoginComponent, LogoutComponent, AccessDeniedComponent],
})
export class LibAuthenticationModule {
    static forRoot(): ModuleWithProviders<LibAuthenticationModule> {
        return {
            ngModule: LibAuthenticationModule,
            providers: [AuthenticationService, AuthenticationStore, AuthGuard, UserService],
        };
    }
}
